import query from "./index";
import { BetType } from "../types/common";

export type SportFeedConfig = ReturnType<typeof query.footballFeed>;

export type SportKey =
  | "football"
  | "basketball"
  | "volleyball"
  | "tabletennis"
  | "tennis"
  | "handball"
  | "icehockey"
  | "snooker"
  | "baseball"
  | "rugby"
  | "americanfootball"
  | "badminton"
  | "boxing"
  | "bull_fight"
  | "cock_fight"
  | "cricket";

type FeedType = "today" | "live" | "early";

const FEEDS_WITH_BETTYPE: Record<
  Extract<
    SportKey,
    | "football"
    | "basketball"
    | "volleyball"
    | "tabletennis"
    | "tennis"
    | "handball"
    | "icehockey"
    | "snooker"
    | "baseball"
    | "rugby"
    | "americanfootball"
    | "badminton"
  >,
  (type: FeedType, betType: BetType, provider?: string) => SportFeedConfig
> = {
  football: (type, betType, provider) =>
    query.footballFeed(type, betType, provider),
  basketball: (type, betType, provider) =>
    query.basketballFeed(type, betType, provider),
  volleyball: (type, betType) => query.volleyballFeed(type, betType),
  tabletennis: (type, betType) => query.tabletennisFeed(type, betType),
  tennis: (type, betType) => query.tennisFeed(type, betType),
  handball: (type, betType) => query.handballFeed(type, betType),
  icehockey: (type, betType) => query.icehockeyFeed(type, betType),
  snooker: (type, betType) => query.snookerFeed(type, betType),
  baseball: (type, betType) => query.baseballFeed(type, betType),
  rugby: (type, betType) => query.rugbyFeed(type, betType),
  americanfootball: (type, betType) =>
    query.americanfootballFeed(type, betType),
  badminton: (type, betType) => query.badmintonFeed(type, betType),
};

const FEEDS_NO_BETTYPE: Record<
  Extract<SportKey, "boxing" | "bull_fight" | "cock_fight" | "cricket">,
  (type: FeedType) => SportFeedConfig
> = {
  boxing: (type) => query.boxingFeed(type),
  bull_fight: (type) => query.bullfightFeed(type),
  cock_fight: (type) => query.cockfightFeed(type),
  cricket: (type) => query.cricketFeed(type),
};

export function getSportFeedQuery(
  sport: SportKey,
  type: FeedType,
  betType: BetType = "normal",
  provider?: string,
): SportFeedConfig {
  if (sport in FEEDS_WITH_BETTYPE) {
    return FEEDS_WITH_BETTYPE[sport as keyof typeof FEEDS_WITH_BETTYPE](
      type,
      betType,
      provider,
    );
  }
  if (sport in FEEDS_NO_BETTYPE) {
    return FEEDS_NO_BETTYPE[sport as keyof typeof FEEDS_NO_BETTYPE](type);
  }
  return query.footballFeed(type, betType, provider);
}
